import {
    // FILE_UPLOAD,
    CREATE_SJFFAQS,
    RETRIEVE_SJFFAQS,
    UPDATE_SJFFAQS,
    DELETE_SJFFAQS,
    RETRIEVESINGLE_SJFFAQS,
} from "./type";
import SJFFAQs from "../service/sjfFAQs";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await SJFFAQs.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await SJFFAQs.create(data);
        dispatch({
            type: CREATE_SJFFAQS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await SJFFAQs.fetchList(data);
        dispatch({
            type: RETRIEVE_SJFFAQS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await SJFFAQs.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SJFFAQS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await SJFFAQs.update(data);
        dispatch({
            type: UPDATE_SJFFAQS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await SJFFAQs.changeStatus(data);
//         dispatch({
//             type: UPDATE_SJFFAQS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await SJFFAQs.trash(data);
        dispatch({
            type: DELETE_SJFFAQS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};